import {axios} from "../../../axiosConfig";

export function apiGetDashboardData(callback, error){
    axios.get("api/admin/v1/dashboard")
        .then(response =>
            callback(response.data.data))
        .catch(err=>error(err));
}
